module.exports = __webpack_public_path__ + "static/media/email2.0f9104e1.svg";